'use strict';

var React = require('react');

const BannerContext = /*#__PURE__*/React.createContext(false);

exports.BannerContext = BannerContext;
